import { Card, CardContent, TextField } from "@material-ui/core";
import { Fragment } from "react";
import React, { Component } from "react";
import GridItem from "components/Grid/GridContainer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { withTheme } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import toastr from "toastr";

import axios from "../../../config/axios";
import { connect } from "react-redux";
import { previousDay } from "date-fns";
import qs from "qs";
import loaderIcon from "../../../assets/img/loader.gif";
import DeleteModel from "../../../components/Common/FevoModels/DeleteModel";
// import withStyles from "@material-ui/core/styles/withStyles";
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

class ViewEventDetails extends Component {
  state = {
    id: this.props.location.state.event.id,
    uuid: this.props.location.state.event.uuid,
    studentData: null,
    governmentData: null,
    normalData: null,
    nodata: false,
    // eventData: this.props.location.state.event,
    eventData: this.props.location.state.event._original,
    user_registration_details: this.props.location.state.event._original
      .user_registration_details,
    user_id: "",
    count: 0,
    loading: false,
    booking_alias_id: this.props.location.state.event.booking_alias_id,
    booking_id: this.props.location.state.event.booking_id,
    showVerificationModel: false,
    verificationTitle: "",
  };

  componentDidMount() {
    let {
      id,
      uuid,
      booking_alias_id,
      booking_id,
      user_registration_details,
      eventData,
    } = this.state;
    console.log(this.state, "this.state in viewEventDetails");
    console.log(this.state.id, "this.state.id");
    console.log(user_registration_details, "user_registration_details");
    console.log(
      this.props.location.state.event,
      "this.props.location.state.event"
    );
    console.log(eventData, "eventData user_registration_details");
    console.log(
      id,
      uuid,
      booking_alias_id,
      booking_id,
      "id,uuid,booking_alias_id, booking_id for events"
    );
    // axios.get(`booking/detail/${id}/${uuid}`).then((res) => {
    //   if (res.status === 200) {
    //     console.log(res,)
    //     this.setState({
    //       loading:false
    //     })

    if (
      eventData.user_registration_details &&
      eventData.ticket_type == "STUDENT"
    ) {
      console.log("inside if line 54");
      this.setState({
        nodata: user_registration_details ? false : true,
        studentData: { ...user_registration_details },
        user_id: user_registration_details.user_id,
      });
    } else if (
      eventData.user_registration_details &&
      eventData.registrant_type == "GOVERNMENT"
    ) {
      console.log("at line 65");
      this.setState({
        nodata:
          eventData.user_registration_details &&
          eventData.user_registration_details.length > 0
            ? false
            : true,
        governmentData: [...user_registration_details],
        user_id: user_registration_details.user_id,
      });
    } else if (
      eventData.user_registration_details &&
      eventData.registrant_type == "NORMAL"
    ) {
      console.log("at line 81");

      this.setState({
        nodata:
          eventData.user_registration_details &&
          eventData.user_registration_details.length > 0
            ? false
            : true,
        normalData: [...user_registration_details],
        user_id: user_registration_details.user_id,
      });
    } else {
      console.log(user_registration_details, "res in else");
      this.setState({
        nodata: true,
      });
    }
    // this.setState({
    //   ...this.state,
    //   loading : false
    // })
    //   }
    // });
  }

  updateEventBookingStatus = () => {
    const { booking_id, booking_status, eventData } = this.state;
    const id = eventData.id;
    console.log(
      booking_status,
      booking_id,
      "updateEventBookingStatus in viewEventDetails"
    );
    debugger;

    axios
      .post(
        `booking/update/bookingsdetailsperBookingID/${id}/${booking_status}`
      )
      .then((res) => {
        if (res.data.status === 200 || res.data.status === 201) {
          this.setState({
            loading: false,
            booking_id: null,
            // activeTab: 3
          });
          const msg = `Booking ${booking_status.toUpperCase()} Successfully`;
          // toastr.success(res.data.message);
          toastr.success(msg);

          // this.getUnapprovedEvents(id);
          setTimeout(() => {
            // this.props.history.push("/admin/manageevents/eventdetail");
            this.props.history.push("/admin/manageevents/eventlist");
            window.location.reload();
          }, 1500);
        } else if (res.data.status === 204) {
          this.setState({
            loading: false,
            booking_id: null,
            // activeTab: 3
          });
          toastr.error(res.data.message);
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          booking_id: null,
          // activeTab: 3
        });
        toastr.error(error.response.data.message);
      });
  };

  render() {
    console.log(
      this.props.location.state.event,
      "this.props.location.state.event"
    );
    console.log(this.props, "this.props");
    console.log(
      this.props.location.state.event.mobile,
      "this.props individual mobile"
    );

    const { classes } = this.props;
    const theme = withTheme();
    const {
      studentData,
      governmentData,
      nodata,
      id,
      user_id,
      normalData,
      count,
      eventData,
      showVerificationModel,
      verificationTitle,
      booking_id,
      loading,
    } = this.state;
    console.log(normalData, studentData, eventData, governmentData,"normalData");
    console.log(this.state, "this.state in viewEventDetails");

    let general_length =
      normalData && normalData.length > 0
        ? normalData.length
        : governmentData && governmentData.length > 0
        ? governmentData.length
        : 0;
    console.log(this.state, "this.state");

    return (
      <div>
        <div
          style={{
            display: general_length > 1 ? "" : "none",
            justifyContent: "center",
            textAlign: "center",
            padding: "10px",
            margin: "20px",
          }}
        >
          <button
            className={`btn ${count === 0 ? "disable_btn" : ""}`}
            disabled={count === 0 ? "disabled" : false}
            onClick={() => {
              this.setState({
                count: this.state.count - 1,
              });
            }}
          >
            Prev
          </button>
          <span
            style={{
              fontWeight: "bold",
              color: "#0064A0",
              fontSize: "large",
              margin: "15px",
            }}
          >
            Registrant {count + 1}
          </span>
          <button
            className={`btn ${
              count == general_length - 1 ? "disable_btn" : ""
            }`}
            disabled={count == general_length - 1 ? "disabled" : false}
            onClick={() => {
              this.setState({
                count: this.state.count + 1,
              });
            }}
          >
            Next
          </button>
        </div>
        <Card
          className="main_wrapper_tabs"
          style={{ overflow: "-webkit-paged-x" }}
        >
          <CardContent style={{ paddingLeft: "60px",marginBottom: "80px" }}>
            <GridContainer>
              {/* <GridItem md={12}>
                  <label>User Id</label>
                  <TextField
                    InputLabelProps={{
                      shrink: id ? true : false,
                    }}
                    autoFocus
                    margin="dense"
                    id="Webinar_id"
                    name="Webinar_id"
                    type="text"
                    fullWidth
                    value={
                      user_id
                    }
                    disabled={true}
                  />
                </GridItem>
                <GridItem md={12} style={{ marginTop: "10px" }}>
                  <label>Salutation</label>
                  <TextField
                    InputLabelProps={{
                      shrink: id ? true : false,
                    }}
                    autoFocus
                    margin="dense"
                    id="country"
                    name="country"
                    type="text"
                    fullWidth
                    value={
                      studentData
                        ? studentData.salutation
                        : normalData
                        ? normalData[count].salutation
                        : ""
                    }
                    disabled={true}
                  />
                </GridItem> */}

              <GridItem md={12} style={{ marginTop: "10px" }}>
                <label>Full Name</label>

                <TextField
                  InputLabelProps={{
                    shrink: id ? true : false,
                  }}
                  margin="dense"
                  id="email_id"
                  name="email_id"
                  type="text"
                  fullWidth
                  value={
                    studentData
                      ? studentData[0].first_name
                      : normalData
                      ? normalData[count].first_name
                      : governmentData
                      ? governmentData[count].first_name
                      : eventData.ticket_type == 'VIP'
                      ? eventData.user_registration_details[0].first_name
                      : eventData.name

                  }
                  disabled={true}
                />
              </GridItem>
              <GridItem md={12} style={{ marginTop: "10px" }}>
                <label>Email</label>
                <TextField
                  InputLabelProps={{
                    shrink: id ? true : false,
                  }}
                  margin="dense"
                  id="student_id"
                  name="student_id"
                  type="text"
                  fullWidth
                  value={
                    studentData
                      ? studentData[0].email
                      : normalData
                      ? normalData[count].email
                      : governmentData
                      ? governmentData[count].email
                      : eventData.ticket_type == 'VIP'
                      ? eventData.user_registration_details[0].email
                      : eventData.email
                  }
                  disabled={true}
                />
              </GridItem>
              {!governmentData && (
                <GridItem md={12}>
                  <label>Mobile</label>
                  <TextField
                    InputLabelProps={{
                      shrink: id ? true : false,
                    }}
                    margin="dense"
                    id="salutation_seat"
                    name="Salutation"
                    type="text"
                    fullWidth
                    value={
                      studentData
                        ? studentData[0].mobile
                        : normalData
                        ? normalData[count].mobile
                        : eventData.ticket_type == 'VIP'
                        ? eventData.user_registration_details[0].mobile
                        : eventData.mobile
                    }
                    disabled={true}
                  />
                </GridItem>
              )}
              <GridItem md={12} style={{ marginTop: "10px" }}>
                <label>Country</label>
                <TextField
                  InputLabelProps={{
                    shrink: id ? true : false,
                  }}
                  margin="dense"
                  id="school_name"
                  name="school_name"
                  type="text"
                  fullWidth
                  value={
                    studentData
                      ? studentData[0].country.country_name
                      : normalData
                      ? normalData[count].country.country_code
                      : governmentData
                      ? governmentData[0].country.country_name
                      : eventData.ticket_type == 'VIP'
                      ? eventData.user_registration_details[0].country.country_name
                      : eventData.country_name
                  }
                  disabled={true}
                />
              </GridItem>
              {!governmentData && (
                <Fragment>
                  <GridItem md={12} style={{ marginTop: "10px" }}>
                    <label>
                      {studentData
                        ? "Faculty"
                        : normalData
                        ? "Department"
                        : eventData
                        ? "Organisation"
                        : ""}
                    </label>

                    <TextField
                      InputLabelProps={{
                        shrink: id ? true : false,
                      }}
                      margin="dense"
                      id="faculty"
                      name="faculty"
                      type="text"
                      fullWidth
                      value={
                        studentData
                          ? studentData[0].faculty
                          : normalData
                          ? normalData[count].department
                          : governmentData
                          ? governmentData[0].org
                          : eventData.ticket_type == 'VIP'
                          ? eventData.user_registration_details[0].org
                          : eventData.org
                      }
                      disabled={true}
                    />
                  </GridItem>

                  <GridItem md={12} style={{ marginTop: "10px" }}>
                    <label>
                      {studentData
                        ? "School"
                        : normalData || eventData
                        ? "Designation"
                        : ""}
                    </label>

                    <TextField
                      InputLabelProps={{
                        shrink: id ? true : false,
                      }}
                      margin="duration"
                      id="full_name"
                      name="full_name"
                      type="text"
                      fullWidth
                      value={
                        studentData
                          ? studentData[0].org
                          : normalData
                          ? normalData[count].designation
                          : eventData.ticket_type == 'VIP'
                          ? eventData.user_registration_details[0].designation
                          : eventData.designation
                      }
                      disabled={true}
                    />
                  </GridItem>
                </Fragment>
              )}
              <GridItem md={12} style={{ marginTop: "10px" }}>
                <label>
                  {studentData
                    ? "School Id"
                    : normalData || governmentData || eventData
                    ? "One booking Id"
                    : ""}
                </label>
                <TextField
                  InputLabelProps={{
                    shrink: id ? true : false,
                  }}
                  margin="dense"
                  id="mobile"
                  name="mobile"
                  type="text"
                  fullWidth
                  value={
                    studentData
                      ? studentData[0].student_id
                      : normalData
                      ? normalData[count].main_booking_id
                      : governmentData
                      ? governmentData[count].main_booking_id
                      : eventData.ticket_type == 'VIP'
                      ? eventData.user_registration_details[0].main_booking_id
                      : eventData.main_booking_id
                  }
                  disabled={true}
                />
              </GridItem>

              {governmentData && (
                <GridItem md={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="government_email_id"
                    name="sub_bussiness_unit"
                    label="Sub Bussiness Unit"
                    type="text"
                    fullWidth
                    value={governmentData[count].industry}
                    disabled={true}
                  />
                </GridItem>
              )}

              {studentData && (
                <GridItem
                  md={12}
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  style={{ marginTop: "30px" }}
                >
                  <legend>Student Id Proof</legend>
                  {studentData &&
                  studentData[0].id_proof.includes("application/pdf") ? (
                    <div style={{ 
                    width: "80%",
                    height : "400px",
                    }}>
                      <object
                        data={studentData && studentData[0].id_proof}
                        type={"application/pdf"}
                        width="100%"
                        height="100%"
                      ></object>
                    </div>
                  ) : (
                    <img
                      className="banner_images_main"
                      src={studentData[0].id_proof}
                      alt="banner_img"
                    ></img>
                  )}
                </GridItem>
              )}
            </GridContainer>
          </CardContent>
        </Card>
        <DeleteModel
          // showModalReject={showModalReject}
          showModel={showVerificationModel}
          // showModalReject={showModalReject}
          title={verificationTitle}
          onCancel={() => {
            this.setState({
              showModalReject: false,
              showVerificationModel: false,
              booking_id: null,
            });
          }}
          // onOk={() => {
          //   let bookingId = this.state.booking_id;
          //   let status = "rejected";
          //   this.setState({ loading: true, showModalReject: false });
          //   axios
          //     .post(
          //       `booking/update/bookingsdetailsperBookingID/${bookingId}/${status}`
          //     )
          //     .then(res => {
          //       if (res.data.status === 200 || res.data.status === 201) {
          //         this.setState({
          //           loading: false,
          //           booking_id: null,
          //           activeTab: 3
          //         });
          //         toastr.success(res.data.message);
          //         this.getUnapprovedEvents(eventId);
          //         // window.location.reload();
          //       } else if (res.data.status === 204) {
          //         this.setState({
          //           loading: false,
          //           booking_id: null,
          //           activeTab: 3
          //         });
          //         toastr.error(res.data.message);
          //       }
          //     })
          //     .catch(error => {
          //       this.setState({
          //         loading: false,
          //         booking_id: null,
          //         activeTab: 3
          //       });
          //       toastr.error(error.response.data.message);
          //     });
          // }}
          onOk={() => {
            this.setState({
              ...this.state,
              loading: true,
            });
            this.updateEventBookingStatus();
            this.setState({
              showVerificationModel: false,
            });
          }}
        />

        {studentData && eventData.ticket_status != "APPROVED" && (
          <div style={{ textAlign: "center", marginTop: "2%" }}>
            {/* {
                        props.original.user_type!="NORMAL" && props.original.ticket_status==="PENDING" ? */}
            <div className="actions-center">
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled = {eventData.booking_status === 'CANCELED' ? true : false}
                //  className={classes.button}
                style={{ marginRight: "10px" }}
                onClick={() => {
                  // console.log(props,'props.original.booking_id')
                  this.setState({
                    showVerificationModel: true,
                    // showModal: true,
                    // booking_id:props.original.id,
                    booking_status: "approved",
                    verificationTitle:
                      "Do you want to approved the Verification of this booking ?",
                  });
                }}
              >
                APPROVE
              </Button>

              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled = {eventData.booking_status === 'CANCELED' ? true : false}
                //  className={classes.button}

                onClick={
                  () => {
                    this.setState({
                      showVerificationModel: true,
                      // showModalReject : true,
                      // booking_id:props.original.id,
                      booking_status: "rejected",
                      verificationTitle:
                        "Do You want to reject the Verification of this booking ?",
                    });
                  }
                  // ()=>this.updateBookingStatus(props.original.uuid,"rejected")
                }
              >
                Reject
              </Button>
            </div>
            {/* :
                     <div style={{marginLeft: "21%"}}> <span>{props.original.ticket_status =='APPROVED'? 'Approved' : props.original.ticket_status =='PENDING'? 'Pending': props.original.ticket_status}</span></div>} */}
          </div>
        )}

        {loading && (
          <div className="loader_icon">
            <img src={loaderIcon} alt="loader" />
          </div>
        )}
      </div>
    );
  }
}
export default ViewEventDetails;



// WEBPACK FOOTER //
// ./src/views/ISEAS/EventManagement/ViewEventDetails.js